export default __webpack_public_path__ + "static/media/profilepage.d5dec299.PNG";